module.exports = __webpack_public_path__ + "static/bg-9b8015d263377027ddfe847f4d4a5ef1.jpg";